export const TOGGLE_FILE = 'TOGGLE_FILE';
export const SELECT_FILE = 'SELECT_FILE';
export const FILTER_FILES = 'FILTER_FILES';
export const SEARCH_FILES = 'SEARCH_FILES';

export const PREVIEW_FILE = 'PREVIEW_FILE';
export const PREVIEW_FILE_REQUEST = 'PREVIEW_FILE_REQUEST';
export const PREVIEW_FILE_SUCCESS = 'PREVIEW_FILE_SUCCESS';
export const PREVIEW_FILE_ERROR = 'PREVIEW_FILE_ERROR';

export const TRANSLATE_FILES = 'TRANSLATE_FILES';
export const TRANSLATE_FILES_REQUEST = 'TRANSLATE_FILES_REQUEST';
export const TRANSLATE_FILES_SUCCESS = 'TRANSLATE_FILES_SUCCESS';
export const TRANSLATE_FILES_ERROR = 'TRANSLATE_FILES_ERROR';

export const REVIEW_FILE = 'REVIEW_FILE';
export const REVIEW_FILE_REQUEST = 'REVIEW_FILE_REQUEST';
export const REVIEW_FILE_SUCCESS = 'REVIEW_FILE_SUCCESS';
export const REVIEW_FILE_ERROR = 'REVIEW_FILE_ERROR';

export const VIEW_REPORT = 'VIEW_REPORT';
export const VIEW_REPORT_REQUEST = 'VIEW_REPORT_REQUEST';
export const VIEW_REPORT_SUCCESS = 'VIEW_REPORT_SUCCESS';
export const VIEW_REPORT_ERROR = 'VIEW_REPORT_ERROR';

export const dataFactoryList = 'dataFactoryList';
export const dataFactoryList_SUCCESS = 'dataFactoryList_SUCCESS';

export const dataFactoryTable = 'dataFactoryTable';
export const dataFactoryTable_SUCCESS = 'dataFactoryTable_SUCCESS';

export const findByProjectName = 'findByProjectName';
export const findByProjectName_SUCCESS = 'findByProjectName_SUCCESS';



// WEBPACK FOOTER //
// ./src/state/project/types.js